import { Plus, Trash2 } from "lucide-react";
import { api, inr } from "@/lib/api";

export const inputCls = "h-9 w-full rounded-lg border border-zinc-200 px-3 text-sm outline-none focus:border-[#C5A46D]";

export async function openPdf(path) {
  const r = await api.get(path, { responseType: "blob" });
  window.open(URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), "_blank");
}

export function calc(items, gst, discount = 0) {
  const sub = items.reduce((a, i) => a + (Number(i.qty) || 0) * (Number(i.rate) || 0), 0);
  const d = Math.min(Number(discount) || 0, sub);
  const g = ((sub - d) * (Number(gst) || 0)) / 100;
  return { sub, d, g, total: sub - d + g };
}

export function LineItems({ items, onChange, gst, discount, testid = "line-items" }) {
  const set = (i, k, v) => onChange(items.map((it, j) => (j === i ? { ...it, [k]: v } : it)));
  const t = calc(items, gst, discount);
  return (
    <div data-testid={testid} className="space-y-2">
      {items.map((it, i) => (
        <div key={i} className="grid grid-cols-[1fr_70px_110px_32px] gap-2">
          <input data-testid={`${testid}-desc-${i}`} placeholder="Description" value={it.description} onChange={(e) => set(i, "description", e.target.value)} className={inputCls} />
          <input data-testid={`${testid}-qty-${i}`} type="number" min="0" placeholder="Qty" value={it.qty} onChange={(e) => set(i, "qty", e.target.value)} className={inputCls} />
          <input data-testid={`${testid}-rate-${i}`} type="number" min="0" placeholder="Rate" value={it.rate} onChange={(e) => set(i, "rate", e.target.value)} className={inputCls} />
          <button type="button" data-testid={`${testid}-remove-${i}`} onClick={() => onChange(items.filter((_, j) => j !== i))} className="text-zinc-400 hover:text-rose-500"><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <button type="button" data-testid={`${testid}-add`} onClick={() => onChange([...items, { description: "", qty: 1, rate: 0 }])} className="flex items-center gap-1 text-xs font-bold text-[#C5A46D]"><Plus className="h-3.5 w-3.5" />Add line</button>
      <div data-testid={`${testid}-totals`} className="ml-auto w-64 space-y-0.5 text-right text-xs text-zinc-500">
        <div>Subtotal {inr(t.sub)}</div>{t.d > 0 && <div>Discount −{inr(t.d)}</div>}<div>GST {gst || 0}% {inr(t.g)}</div>
        <div className="text-base font-extrabold text-[#C5A46D]">Total {inr(t.total)}</div>
      </div>
    </div>
  );
}
